var r = /* @__PURE__ */ ((e) => (e.ENABLED = "enabled", e.DISABLED = "disabled", e))(r || {}), a = /* @__PURE__ */ ((e) => (e.VIEWED = "b-motion-viewed", e))(a || {});
export {
  a as M,
  r as a
};
